export const webDev = [
  {
    title: "C++",
    value: "85%",
  },
  // {
  //   title: "Java",
  //   value: "45%",
  // },
  {
    title: "Python",
    value: "85%",
  },
  {
    title: "JavaScript",
    value: "75%",
  },
  {
    title: "React.JS",
    value: "92%",
  },
  {
    title: "Next.JS",
    value: "55%",
  },
  {
    title: "MongoDB",
    value: "75%",
  },
  {
    title: "SQL",
    value: "75%",
  },
  {
    title: "Redis",
    value: "75%",
  },
  {
    title: "ThreeJS",
    value: "90%",
  },
  {
    title: "FastAPI",
    value: "65%",
  },
  // {
  //   title: "Scikit-Learn",
  //   value: "40%",
  // },
  {
    title: "Pandas",
    value: "40%",
  },
  {
    title: "Matplotlib",
    value: "40%",
  },
  // {
  //   title: "PostgreSQL",
  //   value: "75%",
  // },
  // {
  //   title: "Python",
  //   value: "70%",
  // },
  // {
  //   title: "JavaScript",
  //   value: "75%",
  // },
  // {
  //   title: "TypeScript",
  //   value: "70%",
  // },
  // {
  //   title: "NodeJS",
  //   value: "70%",
  // },
  // {
  //   title: "EJS",
  //   value: "90%",
  // },
  {
    title: "Django",
    value: "65%",
  },
  // {
  //   title: "Next.JS",
  //   value: "55%",
  // },
  {
    title: "A-Frame",
    value: "95%",
  },
  {
    title: "HTML",
    value: "95%",
  },
  {
    title: "CSS",
    value: "90%",
  },
  // {
  //   title: "Webflow",
  //   value: "40%",
  // },
];

export const core = [
  {
    title: "System Design & Architecture",
    value: "70%",
  },
  {
    title: "Data Structures",
    value: "95%",
  },
  {
    title: "Object Oriented Programming",
    value: "90%",
  },
  {
    title: "APIs and Microservices",
    value: "90%",
  },
];

export const cyberSecurity = [
  {
    title: "Docker",
    value: "75%",
  },
  {
    title: "Github Actions",
    value: "70%",
  },
  {
    title: "Git & Github",
    value: "60%",
  },
  {
    title: "AWS EC2",
    value: "30%",
  },
  {
    title: "AWS S3",
    value: "30%",
  },
  {
    title: "Kali Linux",
    value: "75%",
  },
  {
    title: " Ubuntu",
    value: "75%",
  },
];
// export const others = [

// ];
